import React, { useState } from 'react';
import classnames from 'classnames';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';
import { string, object } from 'yup'; // for only what you need
import Input from '../components/form/FormikInput';
import Checkbox from '../components/form/FormikCheckbox';
import { ReactComponent as CheckIcon } from '../svg/check.svg';
import Layout from './Layout';
import Loading from '../components/Loading';
import useFeatureFlags from '../hooks/useFeatureFlags';

export const updateAccount = (username, data) => {
    return axios.request({
        url: `${process.env.REACT_APP_API_URL}/authorized/users/${username}`,
        method: 'patch',
        data
    });
};

const accountSchema = object().shape({
    email: string().email().lowercase().required('Email is required'),
    firstname: string().required('First Name is required'),
    lastname: string().required('Last Name is required')
});

const Account = (props) => {
    const session = useSelector((state) => state.session);
    const [success, setSuccess] = useState(null);
    const flags = useFeatureFlags();
    let handleSubmit = (values, { setSubmitting }) => {
        let { user } = session;

        updateAccount(user.username, {
            firstname: values.firstname,
            lastname: values.lastname,
            email: values.email.toLowerCase(),
            notifyonreport: values.royalty_notify
        })
            .then(() => {
                setSuccess(true);
                setTimeout(() => {
                    setSubmitting(false);
                    setSuccess(null);
                }, 3000);
            })
            .catch(() => {
                setSuccess(null);
            });
    };

    return (
        <Layout>
            <div className="page-header">
                <h1>Account</h1>
            </div>
            {session.isLoading && <Loading />}
            {!session.isLoading && (
                <div className="row">
                    <Formik
                        initialValues={{
                            email: session.user.email,
                            firstname: session.user.firstname,
                            lastname: session.user.lastname,
                            royalty_notify: session.user.notifyonreport
                        }}
                        validationSchema={accountSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ values, errors, handleChange, handleSubmit, isSubmitting, setFieldValue }) => (
                            <form className="col-xs-12 col-sm-6 col-md-4" onSubmit={handleSubmit} noValidate>
                                <div className="row">
                                    <div className="col-xs-12 col-md-6">
                                        <Input
                                            id="firstname"
                                            label="First Name"
                                            value={values.firstname}
                                            onChange={handleChange}
                                            errors={errors.firstname}
                                            required
                                        />
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                        <Input
                                            id="lastname"
                                            label="Last Name"
                                            value={values.lastname}
                                            onChange={handleChange}
                                            errors={errors.lastname}
                                            required
                                        />
                                    </div>
                                </div>
                                <Input
                                    id="email"
                                    label="Email"
                                    type="email"
                                    value={values.email}
                                    onChange={handleChange}
                                    errors={errors.email}
                                    required
                                />
                                <Checkbox
                                    id="royalty_notify"
                                    label="Receive royalty report notifications"
                                    onChange={(e) => {
                                        setFieldValue('royalty_notify', e.target.checked);
                                    }}
                                    checked={values.royalty_notify}
                                />
                                <button
                                    className={classnames('btn btn-sm', {
                                        'btn-primary': success === null,
                                        'btn-success': success
                                    })}
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                        {success === null ? (
                                            'Save'
                                        ) : (
                                            <>
                                                <CheckIcon width="1em" height="1em" /> Changes Saved
                                            </>
                                        )}
                                    </button>
                            </form>
                        )}
                    </Formik>
                </div>
            )}
        </Layout>
    );
};

export default Account;
